var map = {
	"./000.png": 2604,
	"./001.png": 6135,
	"./002.png": 9859,
	"./003.png": 6844,
	"./004.png": 3946,
	"./005.png": 5606,
	"./006-risk.png": 2038,
	"./006.png": 6518,
	"./007 (1).png": 1373,
	"./007.png": 3052,
	"./008-ews.png": 2137,
	"./008.png": 3305,
	"./009 .png": 3568,
	"./009.png": 2129,
	"./010.png": 1710,
	"./1 - Copy.png": 7464,
	"./1.png": 14,
	"./1n.png": 7435,
	"./2.png": 8951,
	"./3.png": 3278,
	"./360_risk_report.png": 3261,
	"./360_risk_reports.svg": 6848,
	"./4.png": 9767,
	"./EWS_small.jpg": 8150,
	"./background.png": 8462,
	"./bank lender table.PNG": 5380,
	"./blank_white_laptop.png": 8099,
	"./cbi_background.svg": 5637,
	"./cbi_stack_img.png": 2157,
	"./contruction.png": 21,
	"./crooped_laptop_risk.png": 4871,
	"./crop-2.png": 5855,
	"./document_part_1.png": 3417,
	"./document_part_2.png": 8376,
	"./ews.png": 5187,
	"./ews_part_1.png": 9601,
	"./ews_part_2.png": 262,
	"./ews_small.png": 9484,
	"./laptop-crop.png": 9337,
	"./logo.svg": 7582,
	"./logo_black.png": 7705,
	"./logo_white.jpg": 4983,
	"./logo_white.png": 879,
	"./logo_white_with_background.jpg": 8586,
	"./purple_sign_image.svg": 8890,
	"./purpule_symbol.png": 3596,
	"./risk.png": 5584,
	"./risk_report_big.png": 6633,
	"./risk_report_edge.svg": 8790,
	"./risk_report_part_1.png": 7,
	"./risk_report_part_2.png": 9631,
	"./risk_report_with_laptop.png": 2123,
	"./risk_small.jpg": 2676,
	"./risk_small.png": 9922,
	"./transparent-EWS.png": 7481,
	"./white_backgroun-EWS.png": 1319,
	"./white_background.svg": 3678,
	"./white_background_laptop.svg": 8851,
	"./white_dots.png": 157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;